import { Learning_Type, Learning_Type_Description } from '@app/enums/_index';

import { Factory } from './_factory';
import { LearningType } from '@app/models/_index';

/**
 * Create Learning Type Factory used by application
 * Creates instances of Learning Types
 */
export class LearningTypeFactory implements Factory<LearningType> {
  learningTypes: LearningType[] = [];

  /**
   * Call and build static learning types array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static learning types array to be used to determine the Course learning type
   * Used to show and filter tooltips for a given course detail
   */
  build(): void {
    this.learningTypes.push(
      new LearningType(
        Learning_Type.SELF_STUDY,
        Learning_Type_Description.SELF_STUDY,
        'Embark on self-paced learning with comprehensive eBooks and hands-on lab exercises.'
      )
    );
    this.learningTypes.push(
      new LearningType(
        Learning_Type.QUICK_LEARNING,
        Learning_Type_Description.QUICK_LEARNING,
        'Explore short, focused learning experiences designed to help you quickly build skills.'
      )
    );
    this.learningTypes.push(
      new LearningType(
        Learning_Type.INSTRUCTOR_LED,
        Learning_Type_Description.INSTRUCTOR_LED,
        'Join certified instructors, using comprehensive materials and interactive experiences, in virtual one or multi-day classroom sessions.'
      )
    );
    this.learningTypes.push(
      new LearningType(
        Learning_Type.E_LEARNING,
        Learning_Type_Description.E_LEARNING,
        'Dive into concise, self-paced modules, typically 30 minutes or less, designed for quick learning.'
      )
    );
    this.learningTypes.push(
      new LearningType(
        Learning_Type.CERTIFICATION_EXAM,
        Learning_Type_Description.CERTIFICATION_EXAM,
        'Validate your expertise and showcase your knowledge with certification exams.'
      )
    );
    this.learningTypes.push(
      new LearningType(
        Learning_Type.WEBINAR,
        Learning_Type_Description.WEBINAR,
        'Access recorded sessions and explore targeted topics on the Genesys platform.'
      )
    );
    this.learningTypes.push(
      new LearningType(
        Learning_Type.WORKSHOP,
        Learning_Type_Description.WORKSHOP,
        'Experience immersive, instructor-led sessions with practical labs for hands-on learning available as half day and full day courses.'
      )
    );
  }

  /**
   * Return immutable or copy of Learning Type collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): LearningType[] {
    if (this.learningTypes && this.learningTypes.length === 0) {
      this.build();
    }
    return this.learningTypes.slice();
  }
}
